export default __webpack_public_path__ + "static/media/ig2.8007ceab.svg";